var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataPrivacy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.4999C11.9 21.4999 11.8 21.4957 11.7 21.4874C11.6 21.4791 11.5083 21.4582 11.425 21.4249C9.24166 20.7082 7.49166 19.3832 6.175 17.4499C4.85833 15.5166 4.2 13.4082 4.2 11.1249V6.6249C4.2 6.2467 4.30416 5.90632 4.5125 5.60375C4.72083 5.30119 5 5.08324 5.35 4.9499L11.35 2.6499C11.5667 2.56657 11.7833 2.5249 12 2.5249C12.2167 2.5249 12.4333 2.56657 12.65 2.6499L18.65 4.9499C19 5.08324 19.2792 5.30119 19.4875 5.60375C19.6958 5.90632 19.8 6.2467 19.8 6.6249V11.1249C19.8 13.4082 19.1417 15.5166 17.825 17.4499C16.5083 19.3832 14.7583 20.7082 12.575 21.4249C12.4917 21.4582 12.4 21.4791 12.3 21.4874C12.2 21.4957 12.1 21.4999 12 21.4999ZM12 19.7249C13.7333 19.1874 15.1667 18.1124 16.3 16.4999C17.4333 14.8874 18 13.0957 18 11.1249V6.6249L12 4.3249L6 6.6249V11.1249C6 13.0957 6.56666 14.8874 7.7 16.4999C8.83333 18.1124 10.2667 19.1874 12 19.7249Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPrivacy);
export default __webpack_public_path__ + "static/media/DataPrivacy.87c1fa346bb360e5e59b5f0c7e7ac485.svg";
export { ForwardRef as ReactComponent };